import { ca } from '@cian/analytics';

export function trackSortingChange(label: string) {
  ca('event', {
    action: 'sorting',
    category: 'Listing_KP',
    label,
    name: 'oldevent',
  });
}
